module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-money-bag-2d1f759e4a5061f51de8d7564e364f30.svg";